<section id="file-upload">
  @if (filesListToUpload.length > 0) {
  <div class="row m-tb-15">
    <div class="col-md-6 p-0">
      <mat-form-field class="full-width mb-3">
        <mat-label>Names' Prefix</mat-label>
        <input matInput type="text" [(ngModel)]="nameInput">
      </mat-form-field>
    </div>
  </div>
  }
  <div class="row">
    <div class="col-md-12">
      <h5>Upload one or more file from you computer</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 upload-btn-wrapper">
      <label class="custom-file mb-3" [ngClass]="{'disabled': formValidity}">
        <span class="btn btn-raised btn-success btn-sm">
          Select Files
        </span>
        @if (fileType === 'audio') {
        <input type="file" accept="audio/mpeg, audio/ogg, audio/wav" (change)="onFileSelect($event)" multiple />
        }
        @else if (fileType === 'pdf') {
        <input type="file" accept=".pdf" (change)="onFileSelect($event)" multiple />
        }
      </label>
    </div>
  </div>
  <form class="container p-0" #f="ngForm">
    @if (filesListToUpload.length > 0) {
    @for (selectedFile of filesListToUpload; track selectedFile; let i = $index) {
    <div class="row m-tb-15 align-items-center p-0">
      <div class="col-4">
        <p>{{ selectedFile.file.name }}</p>
      </div>
      <div class="col-3">
        <mat-form-field class="full-width">
          <mat-label>File Name</mat-label>
          <input matInput type="text" placeholder="Music Name" name="filename-{{i}}" [value]="nameInput" ngModel
            required [readonly]="selectedFile.uploadStatus.isSuccess ? true : false" />
        </mat-form-field>
      </div>
      @if (selectedFile.url && selectedFile.uploadStatus.isSuccess && uploadedFiles) {
      <div class="col-3 d-flex justify-content-center">
        @if (fileType && fileType === 'audio') {
        <audio class="audioCenter" [style]="'height: 25px'" preload="none" controls>
          <source [src]="selectedFile.url" type="audio/mp3" />
          Your browser does not support the audio tag.
        </audio>
        }
      </div>
      } @else if (!selectedFile.uploadStatus.isSuccess && uploadedFiles && fileType === 'audio') {
      <div class="col-2 d-flex justify-content-center">
        <span>No preview generated</span>
      </div>
      }
      @if (!selectedFile.url && !selectedFile.uploadStatus.isSuccess) {
        <div class="col-1">
          <button type="button" (click)="onFileDeselect(i)" class="btn btn-light"
            style="border: none;margin: 0;">X
          </button>
        </div>
        }
      <div class="col-2">
        @if (selectedFile.uploadStatus.isSuccess === true) {
        Success
        }
        @else if (selectedFile.uploadStatus.isError === true) {
        Failed
        }
      </div>
    </div>
    }
    <button type="button" class="btn btn-raised btn-secondary btn-sm" (click)="onFileUpload()"
      [disabled]="!f.valid || !f.touched" [ngClass]="f.valid ? 'btn-success' : 'btn-secondary'">
      @if (isUploading) {
      <i class="ft-loader spinner font-small-5"></i>
      }
      @else {
      <span class="fa fa-upload"></span>
      }Upload
    </button>
    }
  </form>
</section>